import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Route guard for pages that require a signed-in account (currently just the
 * image editor). Guests are redirected to /login and returned to the exact URL
 * — pathname + query — after they sign in. Browsing, favorites, collections and
 * downloads stay open to everyone, so this wraps only the editing route.
 */
const RequireAuth = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    // Wait for the auth check to resolve before deciding — otherwise a signed-in
    // user gets bounced to /login on a hard refresh before onAuthStateChanged fires.
    if (loading) {
        return <div className="py-24 text-center text-gray-400">Loading…</div>;
    }

    if (!user) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: { pathname: location.pathname, search: location.search } }}
            />
        );
    }

    return children;
};

export default RequireAuth;
